import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CheckCircle2Icon, XCircleIcon } from 'lucide-react';
const isFor = ['Mujeres que entrenan duro pero se sienten constantemente hinchadas.', 'Emprendedoras y profesionales que necesitan optimizar su energía según su ciclo.', 'Mujeres estancadas en su transformación física a pesar de "hacerlo todo bien".'];
const isNotFor = ['Personas que buscan resultados de la noche a la mañana sin cambiar de mentalidad.', 'Hombres (producto basado exclusivamente en biología femenina).'];
export function WhoIsForSection() {
  return <section className="py-24 bg-emerald-900 relative" data-id="element-200">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-201">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-202">
          {/* WHO IS FOR */}
          <FadeIn data-id="element-203">
            <div className="bg-emerald-950 p-8 md:p-10 rounded-3xl border-t-4 border-gold-500 shadow-xl h-full" data-id="element-204">
              <h3 className="text-2xl font-bold mb-8 flex items-center gap-3" data-id="element-205">
                <span className="text-white" data-id="element-206">ESTO ES PARA TI</span>
                <span className="text-gold-400" data-id="element-207">SI...</span>
              </h3>
              <ul className="space-y-6" data-id="element-208">
                {isFor.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-209">
                    <CheckCircle2Icon className="w-6 h-6 text-gold-400 flex-shrink-0 mt-0.5" data-id="element-210" />
                    <span className="text-emerald-50/90 font-body leading-relaxed" data-id="element-211">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          {/* WHO IS NOT FOR */}
          <FadeIn delay={0.2} data-id="element-212">
            <div className="bg-emerald-950/50 p-8 md:p-10 rounded-3xl border-t-4 border-red-900/50 h-full" data-id="element-213">
              <h3 className="text-2xl font-bold mb-8 flex items-center gap-3 text-emerald-100/50" data-id="element-214">
                NO ES PARA TI SI...
              </h3>
              <ul className="space-y-6" data-id="element-215">
                {isNotFor.map((item, index) => <li key={index} className="flex items-start gap-4 opacity-70" data-id="element-216">
                    <XCircleIcon className="w-6 h-6 text-red-500/50 flex-shrink-0 mt-0.5" data-id="element-217" />
                    <span className="text-emerald-50/70 font-body leading-relaxed" data-id="element-218">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}